// Painel de habilitação da transportadora (PO1-3106). Rotas liberadas pela
// trava do modo habilitação; a transportadora vem do token.
import api from "./api";

export async function getPainelHabilitacao() {
  const { data } = await api.get("/habilitacao/painel");
  return data;
}

export async function salvarContatoTi(idVinculo, { nome, email, ddd, telefone }) {
  const { data } = await api.put(`/habilitacao/vinculos/${idVinculo}/contato-ti`, { nome, email, ddd, telefone });
  return data;
}

// "Corrigi, enviar de novo": DEVOLVIDO → EM_CONFIGURACAO.
export async function reenviarHomologacao(idVinculo) {
  const { data } = await api.post(`/habilitacao/vinculos/${idVinculo}/reenviar-homologacao`);
  return data;
}
